import { UUID } from "src/common/types/primitives";
import { FetchingOptions, monolithFetcher } from "src/common/utils/fetching";

export type GetMyUserIdResponse = UUID;

/* istanbul ignore next */
export async function getMyUserId(options?: FetchingOptions): Promise<Response> {
  return monolithFetcher("/doc/getMyId", {}, options);
}
